import { requireStates, ConnectComponent2 } from "util";
import View from "./view";
import Presenter from "./presenter";

const initialStates = [
  {
    name: "app.registration.customer.view",
    url: "/:customerUuid",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/view/index.js